import { makeStyles } from "@mui/styles";
import tinycolor from "tinycolor2";
const lightenRate = 45;

export default makeStyles((theme) => ({
  overallcont: {
    minWidth: 242,
    border: "1px solid #E4E7EC",
    borderRadius: 8,
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: tinycolor(theme.palette.primary.main)
        .lighten(lightenRate)
        .toHexString(),
      border: `1px solid ${theme.palette.primary.main}`
    },
    "& hr": {
      marginBlock: "0px",
      border: "1px solid #E4E7EC"
    }
  },
  bottomcont: {
    display: "flex",
    padding: "0px 24px",
    justifyContent: "space-between",
    alignItems: "center"
  },
  noticecard: (props) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "9px",
    border: "1px solid #E4E7EC",
    margin: "10px",
    borderRadius: 8,
    "& h5": {
      fontSize: "14px",
      fontWeight: "500",
      color: "#40444B",
      marginBlock: "0px"
    },
    "& h4": {
      fontSize: "12px",
      borderRadius: "3px",
      fontWeight: "500",
      color: "white",
      cursor: "pointer",
      marginBlock: "0px"
    },
    "& span": {
      color: props?.priority === "high" ? "red" : props?.priority === "medium" ? "#0291d9" : "#040299"
    },
    "& p": {
      color: "#667185"
    }
  })
}));
